export default __webpack_public_path__ + "assets/images/0a1de4058226ad807fe2d34bff895b97.png";